// src/modules/app-views/_apps/appmulti/receivables/pages/Init/components/tableColumns/valueColumn.js
import translateX from 'utils/translateX';
import financialService from 'services/financialService';

function valueColumn(buildColumnProps, options = {}) {
  const {
    key = 'value',
    title = 'value',
    dataIndex = 'value',
    width = 140,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    align: 'right',
    render: value => {
      if (value == null) return <span className="text-muted">—</span>;
      const formatted = financialService.formatNumber(value, { decimals: 2, locale: 'pt-BR' });
      return <span className="font-weight-semibold">R$ {formatted}</span>;
    },
  };
}

export default valueColumn;
